
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';
import Field from '~/components/Field.vue';

@Component({
    components: {
        Field,
    },
})
export default class GDPRConsents extends Vue {
    get gdprConsents() {
        return UserModule.gdprConsents;
    }

    get hasLegalEntries() {
        return ((Object.entries(this.gdprConsents)).length > 0);
    }
}
